import ThirdPartyLinkingDialog from "./ThirdPartyLinkingDialog";
import CookieComplianceDialog from "./CookieComplianceDialog";
import D9HempDialog from "./D9HempDialog";

export const handleDisableBackdropClick = (event, reason) => {
  if (reason === "backdropClick") return false;
};

export default function Dialogs() {
  return (
    <>
      <ThirdPartyLinkingDialog />
      <CookieComplianceDialog />
      <D9HempDialog />
    </>
  );
}
